<template>
  <div>
    <b-field label="First Name">
      <b-input :disabled="editingBlocked" v-model="profile.firstName" :placeholder="placeholderText"></b-input>
    </b-field>
    <b-field label="Last Name">
      <b-input :disabled="editingBlocked" v-model="profile.lastName" :placeholder="placeholderText"></b-input>
    </b-field>
    <b-field label="Email">
      <b-input :disabled="editingBlocked" v-model="profile.email" :placeholder="placeholderText"></b-input>
    </b-field>
    <b-field label="Phone">
      <b-input :disabled="editingBlocked" v-model="profile.phone" :placeholder="placeholderText"></b-input>
    </b-field>
    <b-field label="Company">
      <b-input :disabled="editingBlocked" v-model="profile.company" :placeholder="placeholderText"></b-input>
    </b-field>
  </div>
</template>

<script>

export default {
  name: 'FormOne',
  props: ['editingBlocked', 'profile'],
  data: function() {
    return {
      placeholderText: "Empty, please fill in and save.",
    }
  }
}
</script>

<style scoped>
</style>
